var _regeneratorRuntime = require("/home/kenta/Desktop/decentralized-chat/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/home/kenta/Desktop/decentralized-chat/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('styled-components')) : typeof define === 'function' && define.amd ? define(['react', 'styled-components'], factory) : (global = global || self, global['wavelet-faucet'] = factory(global.react, global['styled-components']));
})(this, function (React, styled) {
  'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  var styled__default = 'default' in styled ? styled['default'] : styled;

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var reactIs_production_min = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: !0
    });
    var b = "function" === typeof Symbol && Symbol.for,
        c = b ? Symbol.for("react.element") : 60103,
        d = b ? Symbol.for("react.portal") : 60106,
        e = b ? Symbol.for("react.fragment") : 60107,
        f = b ? Symbol.for("react.strict_mode") : 60108,
        g = b ? Symbol.for("react.profiler") : 60114,
        h = b ? Symbol.for("react.provider") : 60109,
        k = b ? Symbol.for("react.context") : 60110,
        l = b ? Symbol.for("react.async_mode") : 60111,
        m = b ? Symbol.for("react.concurrent_mode") : 60111,
        n = b ? Symbol.for("react.forward_ref") : 60112,
        p = b ? Symbol.for("react.suspense") : 60113,
        q = b ? Symbol.for("react.memo") : 60115,
        r = b ? Symbol.for("react.lazy") : 60116;

    function t(a) {
      if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;

        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;

              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case h:
                    return a;

                  default:
                    return u;
                }

            }

          case r:
          case q:
          case d:
            return u;
        }
      }
    }

    function v(a) {
      return t(a) === m;
    }

    exports.typeOf = t;
    exports.AsyncMode = l;
    exports.ConcurrentMode = m;
    exports.ContextConsumer = k;
    exports.ContextProvider = h;
    exports.Element = c;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = r;
    exports.Memo = q;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;

    exports.isValidElementType = function (a) {
      return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
    };

    exports.isAsyncMode = function (a) {
      return v(a) || t(a) === l;
    };

    exports.isConcurrentMode = v;

    exports.isContextConsumer = function (a) {
      return t(a) === k;
    };

    exports.isContextProvider = function (a) {
      return t(a) === h;
    };

    exports.isElement = function (a) {
      return "object" === typeof a && null !== a && a.$$typeof === c;
    };

    exports.isForwardRef = function (a) {
      return t(a) === n;
    };

    exports.isFragment = function (a) {
      return t(a) === e;
    };

    exports.isLazy = function (a) {
      return t(a) === r;
    };

    exports.isMemo = function (a) {
      return t(a) === q;
    };

    exports.isPortal = function (a) {
      return t(a) === d;
    };

    exports.isProfiler = function (a) {
      return t(a) === g;
    };

    exports.isStrictMode = function (a) {
      return t(a) === f;
    };

    exports.isSuspense = function (a) {
      return t(a) === p;
    };
  });
  unwrapExports(reactIs_production_min);
  var reactIs_production_min_1 = reactIs_production_min.typeOf;
  var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
  var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
  var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
  var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
  var reactIs_production_min_6 = reactIs_production_min.Element;
  var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
  var reactIs_production_min_8 = reactIs_production_min.Fragment;
  var reactIs_production_min_9 = reactIs_production_min.Lazy;
  var reactIs_production_min_10 = reactIs_production_min.Memo;
  var reactIs_production_min_11 = reactIs_production_min.Portal;
  var reactIs_production_min_12 = reactIs_production_min.Profiler;
  var reactIs_production_min_13 = reactIs_production_min.StrictMode;
  var reactIs_production_min_14 = reactIs_production_min.Suspense;
  var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
  var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
  var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
  var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
  var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
  var reactIs_production_min_20 = reactIs_production_min.isElement;
  var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
  var reactIs_production_min_22 = reactIs_production_min.isFragment;
  var reactIs_production_min_23 = reactIs_production_min.isLazy;
  var reactIs_production_min_24 = reactIs_production_min.isMemo;
  var reactIs_production_min_25 = reactIs_production_min.isPortal;
  var reactIs_production_min_26 = reactIs_production_min.isProfiler;
  var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
  var reactIs_production_min_28 = reactIs_production_min.isSuspense;
  var reactIs_development = createCommonjsModule(function (module, exports) {
    if (process.env.NODE_ENV !== "production") {
      (function () {
        Object.defineProperty(exports, '__esModule', {
          value: true
        }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.

        var hasSymbol = typeof Symbol === 'function' && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

        function isValidElementType(type) {
          return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
        }
        /**
         * Forked from fbjs/warning:
         * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
         *
         * Only change is we use console.warn instead of console.error,
         * and do nothing when 'console' is not supported.
         * This really simplifies the code.
         * ---
         * Similar to invariant but only logs a warning if the condition is not met.
         * This can be used to log issues in development environments in critical
         * paths. Removing the logging code for production environments will keep the
         * same logic and follow the same code paths.
         */


        var lowPriorityWarning = function lowPriorityWarning() {};

        {
          var printWarning = function printWarning(format) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });

            if (typeof console !== 'undefined') {
              console.warn(message);
            }

            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };

          lowPriorityWarning = function lowPriorityWarning(condition, format) {
            if (format === undefined) {
              throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
            }

            if (!condition) {
              for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
              }

              printWarning.apply(undefined, [format].concat(args));
            }
          };
        }
        var lowPriorityWarning$1 = lowPriorityWarning;

        function typeOf(object) {
          if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;

            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;

                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;

                  default:
                    var $$typeofType = type && type.$$typeof;

                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;

                      default:
                        return $$typeof;
                    }

                }

              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }

          return undefined;
        } // AsyncMode is deprecated along with isAsyncMode


        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }

        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }

        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }

        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }

        function isElement(object) {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }

        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }

        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }

        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }

        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }

        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }

        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }

        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }

        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }

        exports.typeOf = typeOf;
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isValidElementType = isValidElementType;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
      })();
    }
  });
  unwrapExports(reactIs_development);
  var reactIs_development_1 = reactIs_development.typeOf;
  var reactIs_development_2 = reactIs_development.AsyncMode;
  var reactIs_development_3 = reactIs_development.ConcurrentMode;
  var reactIs_development_4 = reactIs_development.ContextConsumer;
  var reactIs_development_5 = reactIs_development.ContextProvider;
  var reactIs_development_6 = reactIs_development.Element;
  var reactIs_development_7 = reactIs_development.ForwardRef;
  var reactIs_development_8 = reactIs_development.Fragment;
  var reactIs_development_9 = reactIs_development.Lazy;
  var reactIs_development_10 = reactIs_development.Memo;
  var reactIs_development_11 = reactIs_development.Portal;
  var reactIs_development_12 = reactIs_development.Profiler;
  var reactIs_development_13 = reactIs_development.StrictMode;
  var reactIs_development_14 = reactIs_development.Suspense;
  var reactIs_development_15 = reactIs_development.isValidElementType;
  var reactIs_development_16 = reactIs_development.isAsyncMode;
  var reactIs_development_17 = reactIs_development.isConcurrentMode;
  var reactIs_development_18 = reactIs_development.isContextConsumer;
  var reactIs_development_19 = reactIs_development.isContextProvider;
  var reactIs_development_20 = reactIs_development.isElement;
  var reactIs_development_21 = reactIs_development.isForwardRef;
  var reactIs_development_22 = reactIs_development.isFragment;
  var reactIs_development_23 = reactIs_development.isLazy;
  var reactIs_development_24 = reactIs_development.isMemo;
  var reactIs_development_25 = reactIs_development.isPortal;
  var reactIs_development_26 = reactIs_development.isProfiler;
  var reactIs_development_27 = reactIs_development.isStrictMode;
  var reactIs_development_28 = reactIs_development.isSuspense;
  var reactIs = createCommonjsModule(function (module) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = reactIs_production_min;
    } else {
      module.exports = reactIs_development;
    }
  });
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  var ReactPropTypesSecret_1 = ReactPropTypesSecret;

  var printWarning = function printWarning() {};

  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */


  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error; // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.

          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
              err.name = 'Invariant Violation';
              throw err;
            }

            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
          } catch (ex) {
            error = ex;
          }

          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }

          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }
  /**
   * Resets warning cache when testing.
   *
   * @private
   */


  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };

  var checkPropTypes_1 = checkPropTypes;
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  var printWarning$1 = function printWarning$1() {};

  if (process.env.NODE_ENV !== 'production') {
    printWarning$1 = function printWarning$1(text) {
      var message = 'Warning: ' + text;

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }

  function emptyFunctionThatReturnsNull() {
    return null;
  }

  var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */

    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }
    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */


    var ANONYMOUS = '<<anonymous>>'; // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */

    /*eslint-disable no-self-compare*/

    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */


    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    } // Make `instanceof Error` still work for returned errors.


    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }

      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;

            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }

        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }

            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }

          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }

        var propValue = props[propName];

        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }

        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        if (!reactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning$1('Invalid argument supplied to oneOf, expected an array.');
          }
        }

        return emptyFunctionThatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);

          if (type === 'symbol') {
            return String(value);
          }

          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }

      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }

        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }

        for (var key in propValue) {
          if (has$1(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

            if (error instanceof Error) {
              return error;
            }
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (typeof checker !== 'function') {
          printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }

      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }

        for (var key in shapeTypes) {
          var checker = shapeTypes[key];

          if (!checker) {
            continue;
          }

          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        } // We need to check all keys in case some are required but missing from
        // props.


        var allKeys = objectAssign({}, props[propName], shapeTypes);

        for (var key in allKeys) {
          var checker = shapeTypes[key];

          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }

          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;

        case 'boolean':
          return !propValue;

        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }

          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);

          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;

            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;

                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;

        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      } // falsy value can't be a Symbol


      if (!propValue) {
        return false;
      } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      } // Fallback for non-spec compliant Symbols which are polyfilled.


      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    } // Equivalent of `typeof` but with special handling for array and regexp.


    function getPropType(propValue) {
      var propType = typeof propValue;

      if (Array.isArray(propValue)) {
        return 'array';
      }

      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }

      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }

      return propType;
    } // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.


    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }

      var propType = getPropType(propValue);

      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }

      return propType;
    } // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"


    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);

      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;

        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;

        default:
          return type;
      }
    } // Returns class name of the object, if any.


    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }

      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1;
    ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  function emptyFunction() {}

  function emptyFunctionWithReset() {}

  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  var factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret_1) {
        // It is still safe when called from React.
        return;
      }

      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }

    shim.isRequired = shim;

    function getShim() {
      return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  var propTypes = createCommonjsModule(function (module) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    if (process.env.NODE_ENV !== 'production') {
      var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod

      var throwOnDirectAccess = true;
      module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = factoryWithThrowingShims();
    }
  });

  var compare = function compare(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  };

  var defaultBreakpoints = [40, 52, 64].map(function (n) {
    return n + 'em';
  });
  var propType = propTypes.oneOfType([propTypes.number, propTypes.string, propTypes.array, propTypes.object]);

  var cloneFunction = function cloneFunction(fn) {
    return function () {
      return fn.apply(void 0, arguments);
    };
  };

  var get = function get(obj) {
    for (var _len = arguments.length, paths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      paths[_key - 1] = arguments[_key];
    }

    var value = paths.reduce(function (a, path) {
      if (is(a)) return a;
      var keys = typeof path === 'string' ? path.split('.') : [path];
      return keys.reduce(function (a, key) {
        return a && is(a[key]) ? a[key] : null;
      }, obj);
    }, null);
    return is(value) ? value : paths[paths.length - 1];
  };

  var themeGet = function themeGet(path, fallback) {
    if (fallback === void 0) {
      fallback = null;
    }

    return function (props) {
      return get(props.theme, path, fallback);
    };
  };

  var is = function is(n) {
    return n !== undefined && n !== null;
  };

  var isObject = function isObject(n) {
    return typeof n === 'object' && n !== null;
  };

  var num = function num(n) {
    return typeof n === 'number' && !isNaN(n);
  };

  var px = function px(n) {
    return num(n) && n !== 0 ? n + 'px' : n;
  };

  var createMediaQuery = function createMediaQuery(n) {
    return "@media screen and (min-width: " + px(n) + ")";
  };

  var getValue = function getValue(n, scale) {
    return get(scale, n);
  }; // loosely based on deepmerge package


  var merge = function merge(a, b) {
    var result = {};

    for (var key in a) {
      result[key] = a[key];
    }

    for (var _key2 in b) {
      if (!a[_key2] || typeof a[_key2] !== 'object') {
        result[_key2] = b[_key2];
      } else {
        result[_key2] = merge(a[_key2], b[_key2]);
      }
    }

    return result;
  };

  var mergeAll = function mergeAll() {
    var result = {};

    for (var i = 0; i < arguments.length; i++) {
      result = merge(result, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return result;
  };

  var style = function style(_ref) {
    var _func$propTypes;

    var prop = _ref.prop,
        cssProperty = _ref.cssProperty,
        alias = _ref.alias,
        key = _ref.key,
        _ref$transformValue = _ref.transformValue,
        transformValue = _ref$transformValue === void 0 ? getValue : _ref$transformValue,
        _ref$scale = _ref.scale,
        defaultScale = _ref$scale === void 0 ? {} : _ref$scale;
    var property = cssProperty || prop;

    var func = function func(props) {
      var value = get(props, prop, alias, null);
      if (!is(value)) return null;
      var scale = get(props.theme, key, defaultScale);

      var createStyle = function createStyle(n) {
        var _ref2;

        return is(n) ? (_ref2 = {}, _ref2[property] = transformValue(n, scale), _ref2) : null;
      };

      if (!isObject(value)) return createStyle(value);
      var breakpoints = get(props.theme, 'breakpoints', defaultBreakpoints);
      var styles = [];

      if (Array.isArray(value)) {
        styles.push(createStyle(value[0]));

        for (var i = 1; i < value.slice(0, breakpoints.length + 1).length; i++) {
          var rule = createStyle(value[i]);

          if (rule) {
            var _styles$push;

            var media = createMediaQuery(breakpoints[i - 1]);
            styles.push((_styles$push = {}, _styles$push[media] = rule, _styles$push));
          }
        }
      } else {
        for (var _key3 in value) {
          var breakpoint = breakpoints[_key3];

          var _media = createMediaQuery(breakpoint);

          var _rule = createStyle(value[_key3]);

          if (!breakpoint) {
            styles.unshift(_rule);
          } else {
            var _styles$push2;

            styles.push((_styles$push2 = {}, _styles$push2[_media] = _rule, _styles$push2));
          }
        }

        styles.sort(compare);
      }

      return mergeAll.apply(void 0, styles);
    };

    func.propTypes = (_func$propTypes = {}, _func$propTypes[prop] = cloneFunction(propType), _func$propTypes);
    func.propTypes[prop].meta = {
      prop: prop,
      themeKey: key
    };

    if (alias) {
      func.propTypes[alias] = cloneFunction(propType);
      func.propTypes[alias].meta = {
        prop: alias,
        themeKey: key
      };
    }

    return func;
  };

  var compose = function compose() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key4 = 0; _key4 < _len2; _key4++) {
      funcs[_key4] = arguments[_key4];
    }

    var func = function func(props) {
      var n = funcs.map(function (fn) {
        return fn(props);
      }).filter(Boolean);
      return mergeAll.apply(void 0, n);
    };

    func.propTypes = {};
    funcs.forEach(function (fn) {
      func.propTypes = _extends({}, func.propTypes, fn.propTypes);
    });
    return func;
  };

  var mapProps = function mapProps(mapper) {
    return function (func) {
      var next = function next(props) {
        return func(mapper(props));
      };

      for (var key in func) {
        next[key] = func[key];
      }

      return next;
    };
  };

  var variant = function variant(_ref3) {
    var _fn$propTypes;

    var key = _ref3.key,
        _ref3$prop = _ref3.prop,
        prop = _ref3$prop === void 0 ? 'variant' : _ref3$prop;

    var fn = function fn(props) {
      return get(props.theme, [key, props[prop]].join('.'), null);
    };

    fn.propTypes = (_fn$propTypes = {}, _fn$propTypes[prop] = propTypes.oneOfType([propTypes.number, propTypes.string]), _fn$propTypes);
    return fn;
  }; // space


  var spaceScale = [0, 4, 8, 16, 32, 64, 128, 256, 512];

  var getSpace = function getSpace(n, scale) {
    if (!num(n)) {
      return px(get(scale, n, n));
    }

    var isNegative = n < 0;
    var absolute = Math.abs(n);
    var value = get(scale, absolute);

    if (!num(value)) {
      return isNegative ? '-' + value : value;
    }

    return px(value * (isNegative ? -1 : 1));
  };

  var margin = style({
    prop: 'margin',
    alias: 'm',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var marginTop = style({
    prop: 'marginTop',
    alias: 'mt',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var marginBottom = style({
    prop: 'marginBottom',
    alias: 'mb',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var marginLeft = style({
    prop: 'marginLeft',
    alias: 'ml',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var marginRight = style({
    prop: 'marginRight',
    alias: 'mr',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var padding = style({
    prop: 'padding',
    alias: 'p',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var paddingTop = style({
    prop: 'paddingTop',
    alias: 'pt',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var paddingBottom = style({
    prop: 'paddingBottom',
    alias: 'pb',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var paddingLeft = style({
    prop: 'paddingLeft',
    alias: 'pl',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var paddingRight = style({
    prop: 'paddingRight',
    alias: 'pr',
    key: 'space',
    transformValue: getSpace,
    scale: spaceScale
  });
  var space = mapProps(function (props) {
    return _extends({}, props, {
      mt: is(props.my) ? props.my : props.mt,
      mb: is(props.my) ? props.my : props.mb,
      ml: is(props.mx) ? props.mx : props.ml,
      mr: is(props.mx) ? props.mx : props.mr,
      pt: is(props.py) ? props.py : props.pt,
      pb: is(props.py) ? props.py : props.pb,
      pl: is(props.px) ? props.px : props.pl,
      pr: is(props.px) ? props.px : props.pr
    });
  })(compose(margin, marginTop, marginBottom, marginLeft, marginRight, padding, paddingTop, paddingBottom, paddingLeft, paddingRight)); // color

  var textColor = style({
    prop: 'color',
    key: 'colors'
  });
  var backgroundColor = style({
    prop: 'backgroundColor',
    alias: 'bg',
    key: 'colors'
  });
  var color = compose(textColor, backgroundColor); // width

  var getWidth = function getWidth(n, scale) {
    return !num(n) || n > 1 ? px(n) : n * 100 + '%';
  };

  var width = style({
    prop: 'width',
    key: 'widths',
    transformValue: getWidth
  }); // typography

  var getPx = function getPx(n, scale) {
    return px(get(scale, n));
  };

  var fontSize = style({
    prop: 'fontSize',
    key: 'fontSizes',
    transformValue: getPx,
    scale: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  });
  var fontFamily = style({
    prop: 'fontFamily',
    key: 'fonts'
  });
  var fontWeight = style({
    prop: 'fontWeight',
    key: 'fontWeights'
  });
  var lineHeight = style({
    prop: 'lineHeight',
    key: 'lineHeights'
  });
  var textAlign = style({
    prop: 'textAlign'
  });
  var fontStyle = style({
    prop: 'fontStyle'
  });
  var letterSpacing = style({
    prop: 'letterSpacing',
    key: 'letterSpacings',
    transformValue: getPx
  }); // layout

  var display = style({
    prop: 'display'
  });
  var maxWidth = style({
    prop: 'maxWidth',
    key: 'maxWidths',
    transformValue: getPx
  });
  var minWidth = style({
    prop: 'minWidth',
    key: 'minWidths',
    transformValue: getPx
  });
  var height = style({
    prop: 'height',
    key: 'heights',
    transformValue: getPx
  });
  var maxHeight = style({
    prop: 'maxHeight',
    key: 'maxHeights',
    transformValue: getPx
  });
  var minHeight = style({
    prop: 'minHeight',
    key: 'minHeights',
    transformValue: getPx
  });
  var size = mapProps(function (props) {
    return _extends({}, props, {
      width: props.size,
      height: props.size
    });
  })(compose(width, height));
  var verticalAlign = style({
    prop: 'verticalAlign'
  }); // flexbox

  var alignItems = style({
    prop: 'alignItems'
  });
  var alignContent = style({
    prop: 'alignContent'
  });
  var justifyItems = style({
    prop: 'justifyItems'
  });
  var justifyContent = style({
    prop: 'justifyContent'
  });
  var flexWrap = style({
    prop: 'flexWrap'
  });
  var flexBasis = style({
    prop: 'flexBasis',
    transformValue: getWidth
  });
  var flexDirection = style({
    prop: 'flexDirection'
  });
  var flex = style({
    prop: 'flex'
  });
  var justifySelf = style({
    prop: 'justifySelf'
  });
  var alignSelf = style({
    prop: 'alignSelf'
  });
  var order = style({
    prop: 'order'
  }); // grid

  var gridGap = style({
    prop: 'gridGap',
    key: 'space',
    transformValue: getPx,
    scale: spaceScale
  });
  var gridColumnGap = style({
    prop: 'gridColumnGap',
    key: 'space',
    transformValue: getPx,
    scale: spaceScale
  });
  var gridRowGap = style({
    prop: 'gridRowGap',
    key: 'space',
    transformValue: getPx,
    scale: spaceScale
  });
  var gridColumn = style({
    prop: 'gridColumn'
  });
  var gridRow = style({
    prop: 'gridRow'
  });
  var gridAutoFlow = style({
    prop: 'gridAutoFlow'
  });
  var gridAutoColumns = style({
    prop: 'gridAutoColumns'
  });
  var gridAutoRows = style({
    prop: 'gridAutoRows'
  });
  var gridTemplateColumns = style({
    prop: 'gridTemplateColumns'
  });
  var gridTemplateRows = style({
    prop: 'gridTemplateRows'
  });
  var gridTemplateAreas = style({
    prop: 'gridTemplateAreas'
  });
  var gridArea = style({
    prop: 'gridArea'
  }); // borders

  var border = style({
    prop: 'border',
    key: 'borders'
  });
  var borderWidth = style({
    prop: 'borderWidth',
    key: 'borderWidths',
    transformValue: getPx
  });
  var borderStyle = style({
    prop: 'borderStyle',
    key: 'borderStyles'
  });
  var borderColor = style({
    prop: 'borderColor',
    key: 'colors'
  });
  var borderTop = style({
    prop: 'borderTop',
    key: 'borders'
  });
  var borderRight = style({
    prop: 'borderRight',
    key: 'borders'
  });
  var borderBottom = style({
    prop: 'borderBottom',
    key: 'borders'
  });
  var borderLeft = style({
    prop: 'borderLeft',
    key: 'borders'
  });
  var borderRadius = style({
    prop: 'borderRadius',
    key: 'radii',
    transformValue: getPx
  });
  var borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderWidth, borderStyle, borderColor, borderRadius);
  var boxShadow = style({
    prop: 'boxShadow',
    key: 'shadows'
  });
  var opacity = style({
    prop: 'opacity'
  });
  var overflow = style({
    prop: 'overflow'
  }); // backgrounds

  var background = style({
    prop: 'background'
  });
  var backgroundImage = style({
    prop: 'backgroundImage'
  });
  var backgroundSize = style({
    prop: 'backgroundSize'
  });
  var backgroundPosition = style({
    prop: 'backgroundPosition'
  });
  var backgroundRepeat = style({
    prop: 'backgroundRepeat'
  }); // position

  var position = style({
    prop: 'position'
  });
  var zIndex = style({
    prop: 'zIndex',
    key: 'zIndices'
  });
  var top = style({
    prop: 'top',
    transformValue: getPx
  });
  var right = style({
    prop: 'right',
    transformValue: getPx
  });
  var bottom = style({
    prop: 'bottom',
    transformValue: getPx
  });
  var left = style({
    prop: 'left',
    transformValue: getPx
  }); // variants

  var buttonStyle = variant({
    key: 'buttons'
  });
  var textStyle = variant({
    key: 'textStyles',
    prop: 'textStyle'
  });
  var colorStyle = variant({
    key: 'colorStyles',
    prop: 'colors'
  });
  var index_esm =
  /*#__PURE__*/
  Object.freeze({
    defaultBreakpoints: defaultBreakpoints,
    propType: propType,
    cloneFunction: cloneFunction,
    get: get,
    themeGet: themeGet,
    is: is,
    isObject: isObject,
    num: num,
    px: px,
    createMediaQuery: createMediaQuery,
    merge: merge,
    style: style,
    compose: compose,
    mapProps: mapProps,
    variant: variant,
    margin: margin,
    marginTop: marginTop,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    padding: padding,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    space: space,
    textColor: textColor,
    backgroundColor: backgroundColor,
    color: color,
    getWidth: getWidth,
    width: width,
    getPx: getPx,
    fontSize: fontSize,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    lineHeight: lineHeight,
    textAlign: textAlign,
    fontStyle: fontStyle,
    letterSpacing: letterSpacing,
    display: display,
    maxWidth: maxWidth,
    minWidth: minWidth,
    height: height,
    maxHeight: maxHeight,
    minHeight: minHeight,
    size: size,
    verticalAlign: verticalAlign,
    alignItems: alignItems,
    alignContent: alignContent,
    justifyItems: justifyItems,
    justifyContent: justifyContent,
    flexWrap: flexWrap,
    flexBasis: flexBasis,
    flexDirection: flexDirection,
    flex: flex,
    justifySelf: justifySelf,
    alignSelf: alignSelf,
    order: order,
    gridGap: gridGap,
    gridColumnGap: gridColumnGap,
    gridRowGap: gridRowGap,
    gridColumn: gridColumn,
    gridRow: gridRow,
    gridAutoFlow: gridAutoFlow,
    gridAutoColumns: gridAutoColumns,
    gridAutoRows: gridAutoRows,
    gridTemplateColumns: gridTemplateColumns,
    gridTemplateRows: gridTemplateRows,
    gridTemplateAreas: gridTemplateAreas,
    gridArea: gridArea,
    border: border,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    borderColor: borderColor,
    borderTop: borderTop,
    borderRight: borderRight,
    borderBottom: borderBottom,
    borderLeft: borderLeft,
    borderRadius: borderRadius,
    borders: borders,
    boxShadow: boxShadow,
    opacity: opacity,
    overflow: overflow,
    background: background,
    backgroundImage: backgroundImage,
    backgroundSize: backgroundSize,
    backgroundPosition: backgroundPosition,
    backgroundRepeat: backgroundRepeat,
    position: position,
    zIndex: zIndex,
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    buttonStyle: buttonStyle,
    textStyle: textStyle,
    colorStyle: colorStyle
  });
  var dist = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.Flex = exports.Box = void 0;

    var _styledComponents = _interopRequireDefault(styled__default);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === 'function') {
          ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          }));
        }

        ownKeys.forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      }

      return target;
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var Box = (0, _styledComponents.default)('div')({
      boxSizing: 'border-box'
    }, index_esm.space, index_esm.color, index_esm.width, index_esm.fontSize, index_esm.flex, index_esm.order, index_esm.alignSelf);
    exports.Box = Box;
    Box.displayName = 'Box';
    Box.propTypes = _objectSpread({}, index_esm.space.propTypes, index_esm.color.propTypes, index_esm.width.propTypes, index_esm.fontSize.propTypes);
    var Flex = (0, _styledComponents.default)(Box)({
      display: 'flex'
    }, index_esm.flexWrap, index_esm.flexDirection, index_esm.alignItems, index_esm.justifyContent);
    exports.Flex = Flex;
    Flex.displayName = 'Flex';
    Flex.propTypes = _objectSpread({}, index_esm.flexWrap.propTypes, index_esm.flexDirection.propTypes, index_esm.alignItems.propTypes, index_esm.justifyContent.propTypes);
  });
  unwrapExports(dist);
  var dist_1 = dist.Flex;
  var dist_2 = dist.Box;

  function _templateObject7() {
    var data = _taggedTemplateLiteral(["\n    font-family: ", ", HGGrotesk, sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n\n    background: ", ";\n    background-color: ", ";\n\n    border-radius: ", ";\n    border: 1px solid #2e345100;\n    color: ", ";\n    width: 100%;\n    padding: ", ";\n    min-width: 30px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    height: 48px;\n    transition: all 0.2s ease;\n\n    &:hover {\n        cursor: text;\n        border: 1px solid #4a41d1;\n    }\n    &:focus {\n        border: 1px solid #4a41d1;\n        outline: 0;\n    }\n    &::placeholder {\n        font-size: 16px;\n    }\n"]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    var data = _taggedTemplateLiteral(["\n    width: 100%;\n    background-color: #fff;\n    cursor: pointer;\n    text-align: center;\n    font-weight: 600;\n    border: none;\n    padding: 20px;\n    text-decoration: none;\n    display: inline-block;\n    color: #151b35;\n    font-size: 16px;\n    border-radius: 5px;\n"]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    var data = _taggedTemplateLiteral(["\n    outline: none;\n    border: none;\n    min-width: 200px;\n    border-radius: 2px;\n    height: 35px;\n    background-color: #fff;\n    padding: 10px 15px;\n    font-family: ", ", HGGrotesk, sans-serif;\n    font-weight: normal;\n    font-size: ", ";\n    width: ", ";\n\n    &:focus {\n        outline: none;\n    }\n    &::placeholder {\n        color: #717985;\n        opacity: 0.8;\n    }\n    &:disabled {\n        background-color: #ddd;\n    }\n"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    var data = _taggedTemplateLiteral(["\n    background: none;\n    color: rgba(255, 255, 255, 0.8);\n    border: solid 2px #fff;\n    border-radius: 5px;\n    font-weight: 600;\n    height: auto;\n    width: auto;\n    padding-left: 15px;\n    padding-right: 15px;\n\n    &:hover,\n    &:active {\n        color: #151a36;\n        background-color: #fff;\n        border-color: #fff;\n    }\n"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    var data = _taggedTemplateLiteral(["\n    width: ", ";\n    height: 40px;\n\n    border-radius: ", ";\n    border: 0;\n    outline: 0;\n    text-align: center;\n    vertical-align: middle;\n    line-height: 40px;\n\n    font-family: ", ", HGGrotesk, sans-serif;\n    font-size: ", ";\n    font-weight: normal;\n    color: #fff;\n\n    background-color: ", ";\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:disabled,\n    &[disabled] {\n        pointer-events: none;\n        cursor: default;\n        opacity: 0.3;\n    }\n\n    ", "\n\n    &:active {\n        background-color: rgba(34, 34, 142, 0.5);\n    }\n\n    &:focus {\n        outline: none;\n    }\n"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    var data = _taggedTemplateLiteral(["\n    background-color: #0e1a49;\n    border-radius: 2px;\n    width: 100%;\n    padding: 15px 20px;\n    min-width: 300px;\n    min-height: 100px;\n    ", "\n"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n    margin: 10px 0;\n    color: red;\n"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  var ErrorMessage = styled__default.div(_templateObject());
  var Card = styled__default(dist_1)(_templateObject2(), function (props) {
    return props.showBoxShadow ? "box-shadow: 0 0 12px 6px rgba(155, 155, 155, 0.045);" : "";
  });
  Card.defaultProps = {
    showBoxShadow: true
  };
  var Button = styled__default.button(_templateObject3(), function (props) {
    return props.width;
  }, function (props) {
    return props.theme.borderRadius;
  }, function (props) {
    return props.theme.fontFamily;
  }, function (props) {
    return props.fontSize;
  }, function (props) {
    return props.theme.buttonBackground;
  }, function (props) {
    return props.hideOverflow ? "\n        text-overflow: ellipsis;\n        overflow: hidden;\n    " : "";
  });
  Button.defaultProps = {
    width: "160px",
    fontSize: "16px",
    hideOverflow: false
  };
  var ButtonOutlined = styled__default(Button)(_templateObject4());
  var Input = styled__default.input(_templateObject5(), function (props) {
    return props.theme.fontFamily;
  }, function (props) {
    return props.fontSize;
  }, function (props) {
    return props.width;
  });
  Input.defaultProps = {
    width: "auto",
    fontSize: "14px"
  };
  var WhiteButton = styled__default.button(_templateObject6());
  var StyledInput = styled__default(Input)(_templateObject7(), function (props) {
    return props.theme.fontFamily;
  }, function (props) {
    return props.theme.backdropColor;
  }, function (props) {
    return props.theme.inputBackground;
  }, function (props) {
    return props.theme.borderRadius;
  }, function (props) {
    return props.theme.inputColor;
  }, function (props) {
    return props.theme.inputPadding || "15px";
  });
  var DiscordIcon = 'data:image/svg+xml;base64,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';
  var DiscordIconBlack = 'data:image/svg+xml;base64,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';

  function _templateObject$1() {
    var data = _taggedTemplateLiteral(["\n    margin: 0 auto;\n    width: 70px;\n    text-align: center;\n\n    & > div {\n        width: 18px;\n        height: 18px;\n        background-color: #3c3858;\n\n        border-radius: 100%;\n        display: inline-block;\n        animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n    }\n\n    .bounce1 {\n        animation-delay: -0.32s;\n    }\n\n    .bounce2 {\n        animation-delay: -0.16s;\n    }\n\n    @keyframes sk-bouncedelay {\n        0%,\n        80%,\n        100% {\n            transform: scale(0);\n        }\n        40% {\n            transform: scale(0.8);\n        }\n    }\n"]);

    _templateObject$1 = function _templateObject() {
      return data;
    };

    return data;
  }

  var Spinner = styled__default.div(_templateObject$1());

  var LoadingSpinner = function LoadingSpinner() {
    return React__default.createElement(Spinner, null, React__default.createElement("div", {
      className: "bounce1"
    }), React__default.createElement("div", {
      className: "bounce2"
    }), React__default.createElement("div", {
      className: "bounce3"
    }));
  };

  function _templateObject5$1() {
    var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n  display: inline-block;\n  margin-left: 10px;\n  padding: 0px 10px 0px 30px;\n  line-height: 30px;\n  font-size: 14px;\n  background-position: 10px 50%;\n  background-repeat: no-repeat;\n  background-image: url(", ");\n  background-size: 14px auto;\n  &:active,\n  &:hover {\n    background-image: url(", ");\n  }\n"]);

    _templateObject5$1 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$1() {
    var data = _taggedTemplateLiteral(["\nfont-size: 14px;\n"]);

    _templateObject4$1 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$1() {
    var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n//  height: 70px;\n  margin-bottom: 15px;\n"]);

    _templateObject3$1 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$1() {
    var data = _taggedTemplateLiteral(["\n    width: calc(100% - 40px);\n    display: flex;\n     ", " {\n        border-radius: ", "\n0px\n0px\n        ", ";;\n        flex-grow: 1;\n        height: 40px;\n        padding: 0px;\n        padding-left: 10px;\n        margin: 0;\n        width: auto;\n    }\n    ", " {\n        height: 42px;\n        font-size: 16px;\n        font-weight: 600;\n        background-color: #A0a0a0;\n        color: #151b35;\n        border-radius: ", ";\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n        width: auto;\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n        &:active {\n            background-color: #d4d5da;\n        }\n    }\n"]);

    _templateObject2$1 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$2() {
    var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-align: center;\n  font-weight: normal;\n  color: white;\n  background: ", ";\n  border-radius: 5px;\n  padding: 10px;\n  h1 {\n    margin-top: 0;\n  }\n  ", " {\n    width: auto;\n  }\n  ", " {\n    margin: 20px;\n  }\n  ", " {\n    margin-top: 0;\n  }\n"]);

    _templateObject$2 = function _templateObject() {
      return data;
    };

    return data;
  }

  var Wrapper = styled__default.div(_templateObject$2(), function (props) {
    return props.theme.fontFamily;
  }, function (props) {
    return props.theme.modalBackground;
  }, WhiteButton, StyledInput, Spinner);
  var FormWrapper = styled__default.form(_templateObject2$1(), StyledInput, function (props) {
    return props.theme.borderRadius;
  }, function (props) {
    return props.theme.borderRadius;
  }, Button, function (props) {
    return props.theme.borderRadius;
  });
  var CenterContent = styled__default(dist_1)(_templateObject3$1());
  var FaucetText = styled__default.div(_templateObject4$1());
  var FaucetLink = styled__default(ButtonOutlined)(_templateObject5$1(), DiscordIcon, DiscordIconBlack);

  var Faucet = function Faucet(_ref) {
    var style = _ref.style,
        className = _ref.className,
        url = _ref.url,
        header = _ref.header,
        initial = _ref.address;

    var _React$useState = React.useState(),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        count = _React$useState2[0],
        setCount = _React$useState2[1];

    var _React$useState3 = React.useState(),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        loading = _React$useState4[0],
        setLoading = _React$useState4[1];

    var _React$useState5 = React.useState(initial || ""),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        address = _React$useState6[0],
        setAddress = _React$useState6[1];

    var _React$useState7 = React.useState(0),
        _React$useState8 = _slicedToArray(_React$useState7, 2),
        lastFaucetFetch = _React$useState8[0],
        setLastFaucetFetch = _React$useState8[1];

    React.useEffect(function () {
      var intv = setInterval(checkDiff, 1000);
      checkDiff();
      return function () {
        clearInterval(intv);
      };
    }, []);

    var getPERLs =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(address) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(url || "https://faucet.perlin.net", {
                  method: "POST",
                  body: JSON.stringify({
                    address: address
                  })
                }).then(function (response) {
                  setLastFaucetFetch(Date.now());
                  return response.json();
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getPERLs(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var fetchPERLs = React.useCallback(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var diff, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              diff = Date.now() - lastFaucetFetch;

              if (!(diff > 10000)) {
                _context2.next = 19;
                break;
              }

              setLoading(true);
              _context2.prev = 3;
              _context2.next = 6;
              return getPERLs(address);

            case 6:
              response = _context2.sent;

              if (!(response.result === "ok")) {
                _context2.next = 11;
                break;
              }

              alert("Successfully sent 1000 PERLs.");
              _context2.next = 12;
              break;

            case 11:
              throw new Error(response.result);

            case 12:
              checkDiff();
              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](3);
              alert("An error occurred: " + _context2.t0.message || _context2.t0);

            case 18:
              setLoading(false);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 15]]);
    })), [address]);
    var checkDiff = React.useCallback(function () {
      var diff = Date.now() - lastFaucetFetch;

      if (diff < 10000) {
        setCount(Math.ceil((10000 - diff) / 1000));
      } else {
        setCount(0);
      }
    }, []);
    var addressChangeHandle = React.useCallback(function (event) {
      setAddress(event.target.value);
    }, []);
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(Wrapper, {
      style: style,
      className: className
    }, header ? React__default.createElement("h1", null, "Quick PERL Faucet") : '', React__default.createElement(CenterContent, null, loading ? React__default.createElement(LoadingSpinner, null) : count === 0 ? React__default.createElement(FormWrapper, {
      onSubmit: fetchPERLs
    }, React__default.createElement(StyledInput, {
      value: address,
      placeholder: "Enter a wallet address",
      onChange: addressChangeHandle
    }), React__default.createElement(Button, {
      type: "submit",
      disabled: !address
    }, "Get PERLs")) : count && React__default.createElement("h3", null, "You need wait another ", count, " seconds.")), React__default.createElement(FaucetText, null, "Need more ", React__default.createElement("b", null, "PERLs"), "? Join our", React__default.createElement("a", {
      href: "https://discord.gg/dMYfDPM",
      target: "_blank"
    }, React__default.createElement(FaucetLink, null, "Discord")))));
  };

  function _templateObject5$2() {
    var data = _taggedTemplateLiteral(["\n  font-family: mono;\n  font-size: 20pt;\n  padding-right: 20px;\n  cursor: pointer;\n"]);

    _templateObject5$2 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$2() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject4$2 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$2() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  margin: ", ";\n  padding-left: 20px;\n  margin-bottom: 30px;\n  justify-content: ", ";\n  align-items: ", ";\n"]);

    _templateObject3$2 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$2() {
    var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: ", ";\n  left: 50%;\n  width: 100%;\n  max-width: ", ";\n  color: ", ";\n  transform: translateX(-50%);\n  padding: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  z-index: ", ";\n"]);

    _templateObject2$2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$3() {
    var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  background: ", ";\n"]);

    _templateObject$3 = function _templateObject() {
      return data;
    };

    return data;
  }

  var ModalBackdrop = styled__default.div(_templateObject$3(), function (props) {
    return props.theme.backdropColor;
  });
  var ModalWrapper = styled__default.div(_templateObject2$2(), function (props) {
    return props.theme.modalTop;
  }, function (props) {
    return props.theme.modalMaxWidth;
  }, function (props) {
    return props.theme.modalColor;
  }, function (props) {
    return props.theme.modalPadding || "20px";
  }, function (props) {
    return props.theme.modalBackground;
  }, function (props) {
    return props.theme.modalShadow;
  }, function (props) {
    return props.theme.borderRadius;
  }, function (props) {
    return props.theme.modalZIndex;
  });
  var ModalHeader = styled__default.div(_templateObject3$2(), function (props) {
    return props.theme.headerBackground;
  }, function (props) {
    return props.theme.headerColor;
  }, function (props) {
    return props.theme.fontFamily;
  }, function (props) {
    return props.hasHeader ? "-" + props.theme.modalPadding : "0px";
  }, function (props) {
    return props.hasHeader ? "space-between" : "flex-end";
  }, function (props) {
    return props.hasHeader ? "center" : "";
  });
  var ModalBody = styled__default.div(_templateObject4$2()); // const ModalCloseButton = styled.img.attrs({ src: CloseIcon })`
  //   height: 20px;
  //   width: 20px;
  //   ${props => props.theme.headerColor === 'black' ? 'filter: invert(1);' : ''}
  //   padding-right: 20px;
  //   cursor: pointer;
  // `;

  var ModalCloseButton = styled__default(function (_ref) {
    var onClick = _ref.onClick,
        className = _ref.className;
    return React__default.createElement("div", {
      className: className,
      onClick: onClick
    }, "X");
  })(_templateObject5$2());

  var Modal = function Modal(_ref2) {
    var onClose = _ref2.onClose,
        header = _ref2.header,
        open = _ref2.open,
        children = _ref2.children,
        theme = _ref2.theme;
    var preventEventBubbling = React.useCallback(function (e) {
      e.stopPropagation();
    }, []);
    return React__default.createElement(React__default.Fragment, null, open && React__default.createElement(ModalBackdrop, {
      className: "modal-backdrop",
      onClick: onClose
    }, React__default.createElement(ModalWrapper, {
      className: "modal-wrapper",
      onClick: preventEventBubbling
    }, React__default.createElement(ModalHeader, {
      className: "modal-header",
      justifyContent: "space-between",
      hasHeader: header && true
    }, header, React__default.createElement(ModalCloseButton, {
      className: "modal-close-button",
      onClick: onClose
    })), React__default.createElement(ModalBody, {
      className: "modal-body"
    }, children))));
  };

  var theme = {
    backdropColor: "rgba(0,0,0,0.5)",
    modalBackground: "#14162d",
    borderRadius: "5px",
    modalMaxWidth: "75vw",
    modalTop: "20vh",
    inputBackground: "#121834",
    inputColor: "white",
    breakpoint: {
      xs: "400px",
      s: "600px",
      m: "900px",
      l: "1200px"
    },
    colors: {
      bgDark: "#14162d",
      bgLight: "#1f2137"
    },
    margin: {
      row: "30px"
    }
  };

  var mono = _objectSpread2({}, theme, {
    modalPadding: "5px",
    borderRadius: "0px",
    modalBackground: "black",
    headerBackground: "white",
    buttonBackground: "black",
    headerColor: "black",
    inputBackground: "white",
    inputColor: "black",
    inputPadding: "10px",
    fontFamily: "monospace"
  });

  var FaucetButton = function FaucetButton(_ref) {
    var style = _ref.style,
        className = _ref.className,
        modalHeader = _ref.modalHeader,
        address = _ref.address,
        url = _ref.url,
        defaultTheme = _ref.theme;

    var _React$useState9 = React.useState(false),
        _React$useState10 = _slicedToArray(_React$useState9, 2),
        open = _React$useState10[0],
        setOpen = _React$useState10[1];

    var handleOpen = function handleOpen() {
      return setOpen(true);
    };

    var handleClose = function handleClose() {
      return setOpen(false);
    };

    return React__default.createElement(styled.ThemeProvider, {
      theme: defaultTheme || theme
    }, React__default.createElement("div", null, React__default.createElement(Modal, {
      header: modalHeader ? React__default.createElement("h2", null, "PERL Faucet") : "",
      open: open,
      onClose: handleClose
    }, React__default.createElement(Faucet, {
      address: address,
      header: !modalHeader,
      url: url
    })), React__default.createElement(Button, {
      style: style,
      className: className,
      onClick: handleOpen
    }, "Wavelet Faucet")));
  };

  var index = {
    Faucet: Faucet,
    Modal: Modal,
    FaucetButton: FaucetButton,
    themes: {
      mono: mono,
      defaultTheme: theme
    }
  };
  return index;
});